<template>
    <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="mt-0"
        @click.prevent.stop="$emit('selectConcernElements')"
        :size="size"
    >
        {{ $t('Component(Button):select-concern-elements') }}
    </b-button>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import {BButton} from 'bootstrap-vue'

export default {
    directives: {Ripple},
    components: {BButton},
    props: {
        size: {
            default: 'sm'
        }
    }
}
</script>

<style scoped>

</style>
